module.exports = __webpack_public_path__ + "img/ellio.e9712660.webp";